export default __webpack_public_path__ + "static/media/heart-filled.a44087e2.svg";